import { useState, useEffect } from "react";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const useCurrentTeacher = () => {
  const [teacher, setTeacher] = useState(null);
  const [isTeacher, setIsTeacher] = useState(false);

  const fetchCurrentTeacher = async () => {
    try {
      const res = await fetch(`${BASE_URL}/teacher/logged-in-teacher/`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          "Content-Type": "application/json",
          "x-api-key": process.env.REACT_APP_X_API_KEY
        },
      });

      const data = await res.json();
      setTeacher(data.teacher);
      setIsTeacher(data.is_teacher);
    } catch (err) {
      console.error("Error fetching teacher:", err);
    }
  };

  useEffect(() => {
    fetchCurrentTeacher();
  }, []);

  return { teacher, isTeacher, fetchCurrentTeacher }; // <-- return refresh function
};

export default useCurrentTeacher;
